module.exports = __webpack_public_path__ + "5614a533d148d74341d489f65b882f25.png";